export enum Source {
  JOB = "JOB",
  RESUME = "RESUME",
  BOTH = "BOTH",
  EMPTY = "",
}

export enum Status {
  MATCHED = "MATCHED",
  NEGATIVE_MATCH = "NEGATIVE_MATCH",
  JOB_ONLY = "JOB_ONLY",
  JOBSEEKER_ONLY = "JOBSEEKER_ONLY",
}

export enum InferenceMethod {
  DIRECT = "DIRECT",
  STRONGLY_INFERRED = "STRONGLY_INFERRED",
  WEAKLY_INFERRED = "WEAKLY_INFERRED",
  NONE = "NONE",
  EXTRACTED = "EXTRACTED",
}

type TaxonomyEntity = {
  displayText?: string;
  id?: string;
  inferenceMethod?: InferenceMethod;
  rawName?: string;
  source?: Source;
  status?: Status;
  suid?: string;
  uuid?: string;
};

export default TaxonomyEntity;
